import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import styles from './styles';
import messages from './messages';

class ChatConversationEventBanner extends React.PureComponent {
  render() {
    const { isLocked, intl } = this.props;

    if (!isLocked) return null;

    return (
      <div style={styles.eventLocked} className="kustomer-app-chat-ended-banner">
        {intl.formatMessage(messages.event_session_end)}
      </div>
    );
  }
}

ChatConversationEventBanner.propTypes = {
  isLocked: React.PropTypes.bool,
  intl: intlShape,
};

ChatConversationEventBanner.defaultProps = {
  isLocked: false,
};

export default injectIntl(ChatConversationEventBanner, { withRef: true });
